/**
 * 图库（素材空间 / 选图器）业务规则常量
 *
 * 统一来源，避免 30 / 50 等魔法数字散落在 GalleryPicker、UploadDialog、
 * WangEdit 等多个组件中。需求依据：DEMOZ-7247。
 */

// 上传单批最大文件数（PRD: 单次最多 50 张，超出整批不处理）
export const GALLERY_MAX_UPLOAD_BATCH = 50

// 商品详情描述图片选择上限（PRD: picker 场景下单次最多 30 张）
export const GALLERY_MAX_DETAIL_PICK = 30

// 上传支持的图片格式白名单（PRD: 仅 JPG / PNG / JPEG，禁止 WebP）
export const GALLERY_IMAGE_ACCEPT_TYPES = Object.freeze([
  'image/jpeg',
  'image/jpg',
  'image/png'
])

// 视频格式（不在 DEMOZ-7247 范围内，仅作为常量集中入口，保持现状）
export const GALLERY_VIDEO_ACCEPT_TYPES = Object.freeze([
  'video/mp4',
  'video/avi',
  'video/mov'
])

// HTML <input accept> 字符串形态，便于直接绑定到 file input
export const GALLERY_IMAGE_ACCEPT_STRING = GALLERY_IMAGE_ACCEPT_TYPES.join(',')

export const GALLERY_UPLOAD_ACCEPT_STRING = [
  ...GALLERY_IMAGE_ACCEPT_TYPES,
  ...GALLERY_VIDEO_ACCEPT_TYPES
].join(',')
